export const getCatchImageAlt = (speciesName?: string | null): string =>
  `${speciesName?.length ? speciesName : 'Fish'} caught on Fishbrain`;
